// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__lw3PS","truncatedText":"styles_truncatedText__jKc_4","fullText":"styles_fullText__h7Grr","textContainer":"styles_textContainer__mjQ91"};